export const SPEED_INFRINGEMENT_SETTINGS_COLLECTION = "systemSettings";
export const SPEED_INFRINGEMENT_SETTINGS_DOC = "speedInfringementRules";

export const DEFAULT_SPEED_INFRINGEMENT_RULES = [
  { id: "limit_60_plus_10", speedLimitKph: 60, toleranceKph: 10, enabled: true },
  { id: "limit_80_plus_10", speedLimitKph: 80, toleranceKph: 10, enabled: true },
  { id: "limit_90_plus_10", speedLimitKph: 90, toleranceKph: 10, enabled: true },
  { id: "limit_100_plus_10", speedLimitKph: 100, toleranceKph: 10, enabled: true },
  { id: "limit_120_plus_5", speedLimitKph: 120, toleranceKph: 5, enabled: true },
];

export function normalizeSpeedInfringementRules(rawRules) {
  const rules = Array.isArray(rawRules) ? rawRules : [];
  const rulesById = new Map(rules.filter((rule) => rule?.id).map((rule) => [String(rule.id), rule]));
  const rulesByLimit = new Map(
    rules
      .filter((rule) => Number.isFinite(Number(rule?.speedLimitKph)))
      .map((rule) => [Math.round(Number(rule.speedLimitKph)), rule])
  );

  return DEFAULT_SPEED_INFRINGEMENT_RULES.map((defaultRule) => {
    const rawRule =
      rulesById.get(defaultRule.id) ||
      rulesByLimit.get(Math.round(Number(defaultRule.speedLimitKph))) ||
      {};
    const speedLimitKph = Number(rawRule.speedLimitKph ?? defaultRule.speedLimitKph);
    const toleranceKph = Number(rawRule.toleranceKph ?? defaultRule.toleranceKph);

    return {
      ...defaultRule,
      enabled: rawRule.enabled !== false,
      speedLimitKph: Number.isFinite(speedLimitKph)
        ? speedLimitKph
        : defaultRule.speedLimitKph,
      toleranceKph: Number.isFinite(toleranceKph)
        ? toleranceKph
        : defaultRule.toleranceKph,
    };
  });
}
